import './Formacao.css';

const Formacao = () => {
    return (
        <div class="page-width">
            <div class="pai-formacao">
                <div class="info-title">
                    <h3>Formação</h3>
                </div>
                <div class="formacao">
                    <h4>Análise e Desenvolvimento de Sistemas</h4>
                </div>
                <div class="agrupe-formacao">
                    <div class="instituicao">
                        <h5>Unopar</h5>
                    </div>
                    <div class="button">
                        <p>Em Progresso</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Formacao;